import React from "react";
import { Trans, useTranslation } from "react-i18next";
import SensitiveAmount from "components/sensitive-amount/SensitiveAmount";
import { Onboarding } from "types/Onboarding";

interface OnboardingSalaryProps {
  ob: Pick<Onboarding, "salary" | "salaryChangeDate" | "salaryAfterChange">;
  formatDate: (timestamp: number | null | undefined) => string;
  className?: string;
}

/**
 * The «Salary» cell of an onboarding record card, with the planned second
 * salary under it. When the record comes without a `salary` key there is no
 * cell at all.
 */
export default function OnboardingSalary({ ob, formatDate, className }: OnboardingSalaryProps) {
  const { t } = useTranslation();
  if (ob.salary === undefined) return null;

  return (
    <div className={className}>
      <p className="text-sm text-gray-500">{t("salary")}</p>
      <p>
        <SensitiveAmount value={ob.salary} />
      </p>
      {ob.salaryChangeDate != null && ob.salaryAfterChange != null && (
        <p className="text-xs text-gray-500">
          <Trans
            i18nKey="onboarding_planned_salary_change"
            values={{ date: formatDate(ob.salaryChangeDate) }}
            components={{ amount: <SensitiveAmount value={ob.salaryAfterChange} /> }}
          />
        </p>
      )}
    </div>
  );
}
